
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"315","height":"135"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M101 107.3H86.7v25.1H52v-25.1H.2V81.5l54-79h32.4v78.6h14.3v26.2h.1zM52 81.1V66c0-2.8.1-6.7.3-11.5.2-4.8.4-7.4.5-7.6h-1c-2 4.6-4.3 8.8-6.8 12.8L30.6 81.1H52zm152-13.5c0 23-3.9 39.8-11.6 50.5-7.7 10.7-19.5 16-35.4 16-15.5 0-27.2-5.6-35.1-16.8-7.9-11.2-11.8-27.8-11.8-49.8 0-23.1 3.9-40 11.6-50.8C129.4 5.9 141.2.5 157.1.5c15.5 0 27.1 5.6 35.1 16.8 7.9 11.4 11.8 28.1 11.8 50.3zm-58.9 0c0 14.7.9 24.8 2.8 30.3 1.8 5.5 4.9 8.3 9.2 8.3 4.4 0 7.5-2.8 9.3-8.5 1.8-5.7 2.7-15.7 2.7-30 0-14.4-.9-24.5-2.8-30.3-1.8-5.8-4.9-8.7-9.2-8.7-4.3 0-7.4 2.8-9.2 8.4-1.9 5.5-2.8 15.7-2.8 30.5zm169.2 39.7H300v25.1h-34.7v-25.1h-51.8V81.5l54-79h32.4v78.6h14.3v26.2h.1zm-49-26.2V66c0-2.8.1-6.7.3-11.5.2-4.8.4-7.4.5-7.6h-1c-2 4.6-4.3 8.8-6.8 12.8l-14.4 21.4h21.4z","fill":"#5A7380"}})])
          )
        }
      }
    